export default "__VITE_ASSET__UZ3wUL6l__"